export {
  getCurrentTimeString,
  getDurationMinutesBetweenTimes,
  getEndTimeFromStartAndDurationSeconds,
  getTotalDurationOfTour,
  normalizePrefillLabel,
  resolvePrefillEntityMatch,
  resolveSelectionIndex,
} from './scheduleBuilderUtils';
